import { ReportPartner } from '@helloself/hello-self-ui';

import { Api as API } from '../../config/apiCallDispatcher';
import { MemberSessionAndReportSummaries, MemberSummaryData, PartnerReportData } from './types';
import { RecipientType } from '../consent/types';
import { OrgUnit } from '../../features/user/slice';

export interface CamhsChild {
    addToCareTeamOnLink: 'REFERRING_PARTNER_ONLY' | 'REFERRING_PARTNER_ORG_UNIT';
    partnerCognitoId: string;
    camhsMemberId?: string | null;
    camhsReferralId: number;
    partnerCamhsChildId: number;
    referralName: string;
    referralOrgUnit: {
        id: number; // source organisation of the referral
        fullId: string; // full id (path) of the source organisation
        fullName: string; // full name of the source organisation
    };
    treatmentConsentGivenAt?: number | null;
    treatmentConsentRevokedAt?: number | null;
}

export interface DataShareConsent {
    referringPartnerId?: string | null;
    partnerCamhsChildId: number;
    recipientType: RecipientType;
    recipientName?: string | null;
    recipientEmail?: string | null;
    camhsConsentId: number;
    orgUnit: OrgUnit;
}

// the partner who is this logged in user
export interface ReportPartnerSelf extends ReportPartner {
    ownOrgUnit: OrgUnit;
    descendantOrgUnits: OrgUnit[];
    partnerCamhsChildren?: CamhsChild[] | null;
    partnerDataShareConsent?: DataShareConsent[] | null;
    showConnectionsFeature: boolean;
}

export const getPartnerInfo = async (): Promise<ReportPartnerSelf> => {
    const response = await API.get('partners-read', 'partner');
    return response.data as ReportPartnerSelf;
};

export const getMembersList = async (): Promise<MemberSummaryData> => {
    const response = await API.get('partners-read', 'partners/members');
    return response.data as MemberSummaryData;
};

export const getMemberSessionAndReportSummaries = async (memberId: string) => {
    const response = await API.get('partners-read', `partners/member-summary/${memberId}`);
    return response.data as MemberSessionAndReportSummaries;
};

export const getMemberReport = async (reportId: number) => {
    const response = await API.get('partners-read', `partners/report/${reportId}`);
    return response.data as PartnerReportData;
};
